module.exports = __webpack_public_path__ + "img/pre-initiation_b.cf29fd87.png";